// extracted by mini-css-extract-plugin
export default {"background":"T9VHA","circle":"_1AKuI","skeleton":"_28bk8","filledSkeleton":"_12NHX","text":"_21oQI","star":"_3_YHE","roundStar":"_3VGuD","plus":"_2GyKU"};